/**
 * Created by Tengfei Li on 2026-01-20
 * Table 选择 Hook
 */
import {useCallback, useState} from 'react';

export const useTableSelection = () => {
  const [selectedMacs, setSelectedMacs] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState([]);

  // 添加已选择的 product code
  const addCode = useCallback((code) => {
    if (!selectedCodes.includes(code)) {
      const newCodes = [...selectedCodes];
      newCodes.push(code);
      setSelectedCodes([...newCodes]);
    }
  }, [selectedCodes]);
  // 清空已选择
  const clear = useCallback(() => {
    setSelectedCodes([]);
    setSelectedMacs([]);
  }, [selectedCodes, selectedMacs]);

  return {
    selectedMacs, 
    setSelectedMacs, 
    selectedCodes, 
    addSelectedCode: addCode, 
    clearSelected: clear, 
    rowSelection: {
      onSelect: useCallback(async ({ mac, originalData }, selected) => {
        console.log('onSelect:', mac, originalData);
        const copySelectedRows = new Set([...selectedMacs]);
        if (selected) {
          copySelectedRows.add(mac);
        } else {
          copySelectedRows.delete(mac);
        }
        addCode(originalData.product.code);
        setSelectedMacs([...copySelectedRows]);
      }, [selectedMacs, selectedCodes]),
      onSelectAll: useCallback(async (selected, selectedRows) => {
        console.log('onSelectAll:', selected, selectedRows);

        if (selected) {
          const copySelectedMacs = new Set([...selectedMacs]);
          selectedRows.forEach(({ mac, originalData }) => {
            copySelectedMacs.add(mac);
            addCode(originalData.product.code);
          });
          setSelectedMacs([...copySelectedMacs]);
        } else {
          setSelectedCodes([]);
          setSelectedMacs([]);
        }
      }, [selectedMacs, selectedCodes]),
      selectedRowKeys: selectedMacs,
    },
  };
};